import CastForEducationIcon from "@mui/icons-material/CastForEducation";
import permissions from "app/permissions";
import { EDUCATION_PREPARATORY, STUDENTS_PATH } from "utils/constants";
import ParticipantsPreparatoryList from "./List";
import { tenants } from "utils/tenants";

export const resources = {
  tenancies: [tenants.MU],
  isMenu: true,
  icon: <CastForEducationIcon />,
  name: STUDENTS_PATH + "/" + EDUCATION_PREPARATORY,
  title: "Обучавани в подготвителна година",
  list: <ParticipantsPreparatoryList />,
  permission: permissions.canPreviewStudentEducationInfo,
};
